import { Injectable } from '@angular/core';
import { SQLiteObject } from '@ionic-native/sqlite';
import { DatabaseProvider } from '../database/database';


@Injectable()
export class RotaProvider {

  constructor(public dbProvider: DatabaseProvider) {

  }

  async insert(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'insert into rotas(Rot_Codigo, Rot_Descricao) values (?, ?)';
          for (let val of data) {
            let rota = new Rota();
            rota.codigo = val.Rot_Codigo;
            rota.nome = val.Rot_Descricao;
            let params = [rota.codigo, rota.nome];

            await tx.executeSql(sql, params, (tx, resultSet) => {
              console.log('importou rota');
            }, (err) => {
              console.log('erro:' + err);
            });

          }
        }).then();

      })
      .catch((e) => console.error(e));
  }

  public removeAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'delete from rotas';
        let data = [];

        return db.executeSql(sql, data)
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public getAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM rotas order by Rot_Descricao';

        return db.executeSql(sql, [])
          .then((data: any) => {
            if (data.rows.length > 0) {
              let rotas: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                let rota = new Rota();
                rota.codigo = data.rows.item(i).Rot_Codigo;
                rota.nome = data.rows.item(i).Rot_Descricao;
                rotas.push(rota);
              }
              return rotas;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }


  public get(codigo) {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM rotas where Rot_Codigo = ?';

        return db.executeSql(sql, [codigo])
          .then((data: any) => {
            var rota = new Rota();
            if (data.rows.length > 0) {
              rota.codigo = data.rows.item(0).Rot_Codigo;
              rota.nome = data.rows.item(0).Rot_Descricao;
            }
            return rota;
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }
}

export class Rota {
  codigo: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/providers/rota/rota.ts